// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__MgaD7","container":"styles_container__Xk9k0","list":"styles_list__azlFl"};